import { useMemo } from "react";

/**
 * @param selected: some set of IDs.
 * @param fixed: the set of IDs which should be fixed (i.e., always selected, not de-selectable).
 * @return: the proper array of selected IDs, including any fixed ones, along with a set of the IDs which are fixed (if any).
 */
export function useSelectedIds(
  selected: string[] | string | undefined,
  fixed?: string[] | Set<string>
): {
  selectedIds: string[];
  fixed?: Set<string>;
} {
  return useMemo(() => {
    let array: string[] = fixed ? [...fixed] : [];

    let fixedSet: Set<string> | undefined;
    if (fixed) {
      fixedSet = Array.isArray(fixed) ? new Set(fixed) : fixed;
    }

    if (Array.isArray(selected)) {
      array = array.concat(
        selected.filter(selection => !fixedSet?.has(selection))
      );
    } else if (typeof selected === "string" && !fixedSet?.has(selected)) {
      array.push(selected);
    }

    return {
      selectedIds: array,
      fixed: fixedSet
    };
  }, [selected, fixed]);
}
